'use strict';

// TODO: Review this when all payment go through Stripe.

/**
 * Nature's Menu entry for int_braintree.min.js bundle (see webpack.config-braintree.js).
 */
require('./braintreeSFRA')();
